export default __webpack_public_path__ + "static/media/Emblem_Iron.87ac7556.webp";